<template lang="html">
  <div class="project-details">
    <div class="has-text-centered">
      <span v-if="loadingProject > 0" class="icon has-text-primary is-large">
        <i class="las la-2x la-sync fa-spin"></i>
      </span>
    </div>
    <div v-if="project !== null">
      <section class="hero is-small">
        <div class="hero-body">
          <div class="media">
            <figure class="media-left">
              <icon name="pin" scale="3" class="has-text-primary"></icon>
            </figure>
            <div class="media-content">
              <h1 class="title is-size-4">
                {{ project.name }}
              </h1>
              <h2 class="subtitle">
                {{ project.address.street }}
                <span v-if="showLocationInfo" class="location-tag">
                  ({{ getLocationName() }})
                </span>
              </h2>
            </div>
            <div class="media-right">
              <cw-favorite-button
                :selected="isFavorite"
                @update:selected="updateFavorite"
              ></cw-favorite-button>
            </div>
          </div>
        </div>
      </section>
      <section class="section has-text-centered is-vertical-paddingless">
        <div class="field">
          <div class="control has-icons-left">
            <input
              class="input is-underlined is-medium"
              type="text"
              placeholder="Search Box or Lot"
              v-model="searchQuery"
            />
            <span class="icon is-left">
              <i class="las la-2x la-search"></i>
            </span>
          </div>
        </div>
        <a
          v-if="canCreateOrders"
          class="button is-black is-outlined is-rounded is-large"
          type="button"
          name="button"
          @click="$modal.show('SetRequest')"
        >
          <span class="icon">
            <i class="las la-plus"></i>
          </span>
          <span>Set New Box</span>
        </a>
      </section>
      <section class="section is-top-paddingless">
        <cw-box-list :boxes="filteredBoxes" :selectionHandler="boxSelected" />
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { PROJECT_DETAILS_QUERY } from '@/graphql/constants';
import authRequired from '@/components/mixins/auth-required';
import permissionsRequired from '@/components/mixins/permissions-required';
import autoRefresh from '@/components/mixins/auto-refresh';
import locationAware from '@/components/mixins/location-aware';

// FOR SCREENSHOTS
import Mock from '@/mock-data/screenshots';
import screenshotConfig from '@/components/mixins/screenshot-config';

export default {
  name: 'project-details',
  // share common functionality with component mixins
  mixins: [
    authRequired,
    autoRefresh,
    permissionsRequired,
    screenshotConfig,
    locationAware,
  ],
  props: {},
  // variables
  data() {
    return {
      loadingProject: 0,
      project: null,
      searchQuery: '',
      showLocationInfo: false,
    };
  },
  apollo: {
    project: {
      query: PROJECT_DETAILS_QUERY,
      loadingKey: 'loadingProject',
      variables() {
        return { projectId: this.$route.params.id };
      },
    },
  },
  computed: {
    filteredBoxes() {
      let boxes = this.project.currentDispatchSets;

      if (this.capturingScreenshots) {
        boxes = Mock.currentDispatchSets;
      }

      let query = this.searchQuery.toLowerCase();
      if (query.length > 0) {
        boxes = boxes.filter(info => {
          let matchLot =
            info.subProject.name.toLocaleLowerCase().indexOf(query) > -1;
          let matchBoxNumber =
            info.box && info.box.boxNumber.toLowerCase().indexOf(query) > -1;
          return matchLot || matchBoxNumber;
        });
      }

      return boxes;
    },
    projectId() {
      return this.$route.params.id;
    },
    isFavorite() {
      return (
        this.prefs &&
        this.prefs.favoriteProjects &&
        this.prefs.favoriteProjects[this.projectId]
      );
    },
    ...mapState('user', {
      prefs: state => {
        console.log(state.prefs.favoriteProjects);
        return state.prefs;
      },
    }),
  },
  components: {},
  // methods
  watch: {},
  created() {
    // Check if we should show location information based on multiple locations
    this.showLocationInfo = this.hasMultipleLocations;
  },
  methods: {
    getLocationName() {
      if (!this.project || !this.project.customer) return '';

      return (
        this.project.customer.serviceArea ||
        (this.project.customer.address && this.project.customer.address.city) ||
        this.project.customer.name
      );
    },
    boxSelected(boxSetInfo) {
      this.$router.push({
        path: `/projects/${this.project.projectId}/box/${boxSetInfo.workOrderId}`,
      });
    },
    updateFavorite(f) {
      let favoriteProjects = { ...this.prefs.favoriteProjects };
      if (f) {
        favoriteProjects[this.projectId] = true;
      } else {
        delete favoriteProjects[this.projectId];
      }

      let prefs = { ...this.prefs, favoriteProjects };
      this.$store.commit('user/updatePrefs', { prefs });
    },
  },
  mounted() {
    this.$apollo.queries.project.refetch();
  },
};
</script>

<style lang="stylus" scoped>
.button {
  margin: .5em;
}

.location-tag {
  display: inline-block;
  font-size: 0.9em;
  color: #666;
  margin-left: 0.5em;
}
</style>
